/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdatePaymentRequestEvidenceFileRequest
 */
export interface UpdatePaymentRequestEvidenceFileRequest {
    /**
     * 
     * @type {File}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'file'?: File;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'electronicMethod'?: UpdatePaymentRequestEvidenceFileRequestElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'documentSize'?: UpdatePaymentRequestEvidenceFileRequestDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'heightMillis'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'widthMillis'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'dpiForciblyValid'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'colorGradationForciblyValid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'uploadedByRecipient'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'uploadedFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'invoiceIssuerRegistrationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'invoiceIssuerName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'asQualified'?: boolean | null;
}

export const UpdatePaymentRequestEvidenceFileRequestElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type UpdatePaymentRequestEvidenceFileRequestElectronicMethodEnum = typeof UpdatePaymentRequestEvidenceFileRequestElectronicMethodEnum[keyof typeof UpdatePaymentRequestEvidenceFileRequestElectronicMethodEnum];
export const UpdatePaymentRequestEvidenceFileRequestDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type UpdatePaymentRequestEvidenceFileRequestDocumentSizeEnum = typeof UpdatePaymentRequestEvidenceFileRequestDocumentSizeEnum[keyof typeof UpdatePaymentRequestEvidenceFileRequestDocumentSizeEnum];


